import { createContext } from 'react';

const FormScopeContext = createContext();

export default FormScopeContext;
